type ForumAvatarProps = {
  name: string;
  size?: 'sm' | 'md' | 'lg';
  imageSrc?: string;
};

const sizeClassMap = {
  sm: 'h-10 w-10 text-sm',
  md: 'h-12 w-12 text-base',
  lg: 'h-14 w-14 text-lg',
};

const ForumAvatar = ({
  name,
  size = 'md',
  imageSrc,
}: ForumAvatarProps) => {
  const initial = name.trim().charAt(0).toUpperCase();

  if (imageSrc) {
    return (
      <img
        src={imageSrc}
        alt={name}
        className={`${sizeClassMap[size]} shrink-0 rounded-full object-cover shadow-[0_10px_30px_rgba(15,23,42,0.16)]`}
      />
    );
  }

  return (
    <div
      aria-hidden='true'
      className={`inline-flex ${sizeClassMap[size]} shrink-0 items-center justify-center rounded-full bg-[radial-gradient(circle_at_top_left,#00e5ff_0%,#9bf6ff_42%,#00a8c2_100%)] font-black text-[#202020] shadow-[0_12px_30px_rgba(0,229,255,0.22)]`}
    >
      {initial}
    </div>
  );
};

export default ForumAvatar;
